<template>
    <div class="legalService"  :style="{
            minHeight: `calc(100vh - ${topHeight || 0}px )`,
        }">
        <banner :themeColor="'#fff'"></banner>  
             <div ref="notaryServicesref" class="legalService_content">
                <!-- 专业法律服务资源 -->
                <div class="legalService_content_title">专业法律服务资源</div>
                 <div class="legalService_tabs">
                      <div class="legalService_tabs_item" v-for="(item,index) in tabsItem" :key="index" @click="tabsClick(item._id,item.sort)" :class="item._id==tabsIndex?'tabs_item_active':''">{{item.flmc}}</div>
                 </div>
                 <el-carousel height="585px" indicator-position="outside" :arrow="lsgListData.length>carouselItemCount?'hover':'never'"  class="legalService_content_carousel">
                <el-carousel-item v-for="item in swiperNumber" :key="item" >
                     <div class="carousel_item_body">
                             <div class="carousel_item_box" ref="carouselItemBox" v-for="(items,indexss) in  lsgListData.slice((item-1)*carouselItemCount,item*carouselItemCount)" :key="items">
                                <div class="carousel_item_titleImg">
                                  <div class="carousel_item_img">
                                     <img v-if="items.lstp" :src="commenUrl+items.lstp" alt="">
                                       <img v-else src="@/assets/images/notaryServicers/mrLs.png" alt="">
                                </div>
                                 <div class="carousel_item_img1" v-if="items.lslogo">
                                     <!-- <img :src="commenUrl+items.lslogo"  alt=""> -->
                                     <el-image style="width: 100%; height: 100%" :src="commenUrl+items.lslogo" fit="contain" />
                                </div>
                                </div>
                                <div class="carousel_item_title"> 
                                   <div class="carousel_item_title_text">{{ items.lsmc }}</div>
                                   <div class="carousel_item_title_text1">
                                     <div v-html="items.lsjs"></div>
                                   </div>
                                </div>
                                  <el-carousel height="150px" indicator-position="none" :arrow="items.lawyers.length>4?'hover':'never'" :autoplay="false">
                                  <el-carousel-item v-for="item1 in  Math.ceil(items.lawyers.length/2)" :key="item1">
                                    <div class="carousel_item_lawyer">
                                      <div class="carousel_item_lawyer_body" v-for="lawyers in items.lawyers.slice((item1-1)*4,item1*4)" :key="lawyers">
                                             <div class="carousel_item_lawyer_box">
                                              <div class="carousel_item_lawyer_img">
                                                <img  v-if="lawyers.zp" :src="commenUrl+lawyers.zp" alt="">
                                                <img v-else src="@/assets/images/notaryServicers/mrAvatar.png" alt="">
                                              </div>
                                               <div class="carousel_item_lawyer_text">{{ lawyers.lsxm }}</div>
                                             </div>
                                      </div>
                                </div>
                                  </el-carousel-item>
                                </el-carousel>
   
                        </div>
                     </div>
                </el-carousel-item>
                </el-carousel>
                <!-- 定制化公证咨询服务 -->
                <customization :tabsItem="tabsItem" :themeColor="themeColor"></customization>
                 <!-- <div id="allMap" ></div> -->
             </div>
    </div>
</template>
 
<script>
    // Removed duplicate export default
import { getCurrentInstance,ref,watch,computed,nextTick,onMounted} from "vue";
import { useRoute, useRouter } from "vue-router";
import customization from "./components/customization.vue";
import banner from '@/components/banner.vue'
import MapObject from "@/components/map/js/map";
import mapTdt from "@/components/map/dialogMap.vue"
export default {
  name: "legalService",
    props:{
    themeColor: {
        type: String,
        default: 'blue'
    },
       topHeight: {
        type: Number,
        default: 0
      }
  },
    components:{
        customization,banner
  },
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const route = useRoute();
    let articleData = ref({});

    const carouselItemBox=ref(null)
    const tabsIndex= ref(0);
    const tabsItem = ref([])
    const tabsClick=(id,sort)=>{
        tabsIndex.value=id
        console.log(sort,'sort')
         getlsglList(id,sort)
        }
    
   
    const getTyleList=()=>{   //法律类型接口
      proxy.$request({
        url: "TYPE_LIST",
        method: "post",
        data:{}
      }).then((res) => {
        if (res.data.code == "000") {
         res.data.result.forEach((item,index)=>{
              if(index<=3){
                tabsItem.value.push({
                  sort:index+1,
                  ...item
                })
              }else{
                if(index==4){
                   tabsItem.value.push({
                  sort:1,
                  ...item
                })
                }else if(index==5){
                   tabsItem.value.push({
                  sort:2,
                  ...item
                })
                }else if(index==6){
                   tabsItem.value.push({
                  sort:3,
                  ...item
                })
                }else if(index==7){
                   tabsItem.value.push({
                   sort:4,
                  ...item
                })
                }
              }
          });
          tabsIndex.value=res.data.result[0]._id
          getlsglList(res.data.result[0]._id,0)
        }
      }).catch((err) => {
        console.log(err);
      });
		}
    // getTyleList()
    // LSGL_LIST
    const lsgListData=ref([])
    const  getlsglList=(id,sort)=>{  //律所列表
    proxy.$request({
        url: "LSGL_LIST",
        method: "post",
        data:{
          fwflId:id,
          sort:sort
        }
      }).then((res) => {
        if (res.data.code == "000") {
          lsgListData.value=res.data.result;
          swiperNum()
        }
      }).catch((err) => {
        console.log(err);
      });
    }
     const swiperNumber =ref(0)  //轮播图一页显示几个个数量
       const swiperNum=()=>{
        
              swiperNumber.value = Math.ceil(lsgListData.value.length /  carouselItemCount.value);
       }
        const notaryServicesref = ref(null);
        
        const footerHeight = ref(0);
        const carouselItemCount= ref(4)
        onMounted(async () => {
        await nextTick();
        //  initMap()
        if(notaryServicesref.value){
           carouselItemCount.value=notaryServicesref.value.offsetWidth==1600?4:3
            footerHeight.value = notaryServicesref.value.offsetHeight
            getTyleList()
        }
        
            const debounce = (fn, delay) => {
              let timer = null;
              return function() {
                  if (timer) clearTimeout(timer);
                  timer = setTimeout(() => {
                      fn.apply(this, arguments);
                  }, delay);
              };
};

const debounceSwipNum = debounce(() => {
            if(notaryServicesref.value){
                carouselItemCount.value=notaryServicesref.value.offsetWidth==1600?4:3
                footerHeight.value = notaryServicesref.value.offsetHeight
                swiperNum()
            }
        }, 200);

        window.addEventListener('resize', debounceSwipNum);
        });
        //  const mapCenter = ref([117.6841, 40.51662])
        //    const mapLevel = ref(10);
        //   const mapTypeName = ref('TSM');
        //   const mapObject = ref(null);
        //     const mapConfig = ref({
        //     // 地图属性配置
        //     mouseMove: true, // 开始鼠标移动事件
        //     mapMoved: true, // 地图移动完成事件
        //     mouseDraw: true, // 鼠标绘制
        //     scale:false
        // })
        //        const initMap = ()=> {
        //     // 初始化地图引擎。(DOM ID，初始中心点坐标数组, 初始层级, 初始底图, 其他配置对象)
        //     mapObject.value = new MapObject(
        //         "allMap",
        //         mapCenter.value,
        //         mapLevel.value,
        //         mapTypeName.value,
        //         {
        //             scale: true, // 开启比例尺
        //             ...mapConfig.value,
        //         }
        //     );
        //      mapObject.value.addRouteLine('initRoute',[[119.095572,36.5069605],[118.8,35.8],[118.5,35],[118,34],[117.5,33],[117,32],[116.5,31],[116,30],[115.5,29],[115,28],[114.6,26.5],[114.3,24.5],[114.1899595,22.629046]]);
                   
        //            mapObject.value.addMovingCar('addMovingCar',[ [119.095572,36.5069605],[118.8,35.8],[118.5,35],[118,34],[117.5,33],[117,32],[116.5,31],[116,30],[115.5,29],[115,28],[114.6,26.5],[114.3,24.5],[114.1899595,22.629046]]);
           
        
        // }

    return {
      articleData,
      notaryServicesref,
      tabsClick,
      tabsIndex,
      tabsItem,
      carouselItemBox,
      carouselItemCount,
      lsgListData,
      swiperNumber,
    };
  },
};
</script>

 
<style lang="less" scoped>
.legalService {
    width: 100%;
    height: 100%;
    background: #FFFFFF;
    box-sizing: border-box;
    padding-bottom: 50px;
    .legalService_content {
        // padding: 0 150px;
        width: 1200px;
        margin: 0 auto;
         box-sizing: border-box;
        .legalService_content_title {
             box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 50px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 30px;
            color: #313A4B;
            line-height: 42px;
        }
        .legalService_tabs {
            cursor:pointer;
            margin: 0 auto;
            width: 1000px;
            display: flex;
            justify-content: space-between;
            margin-top:30px ;
            padding-bottom: 10px;
           .legalService_tabs_item{
             font-size: 14px;
             padding-bottom: 10px;
             &:hover {
                 opacity: 0.9;
                font-weight: 500;
                font-size: 14px;
                color: #313A4B;
                border-bottom: 2px solid #313A4B;
                // transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
            }
           }
           .tabs_item_active{
            font-weight: 500;
            font-size: 14px;
            color: #313A4B;
             border-bottom: 2px solid #313A4B;

           }

        }
    }
    .legalService_banner {
         box-sizing: border-box;
        width: 100%;
        height: 400px;
        background: url(../../assets/images/notaryServicers/flfwbanner.png) no-repeat;
        background-size:100% 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .banner_title {
            font-size: 46px;
            font-weight: bold;
            color: #FFFFFF;
        }
        .banner_text {
            margin-top: 20px;
            font-size: 24px;
            font-weight: 400;
            color: #FFFFFF;
        }
    }
}
.legalService_content_carousel {
  margin-top: 40px;
}
.carousel_item_body{
   display: grid;
     grid-template-columns: repeat(3, 1fr); /* 3列，每列等宽 */
     gap: 20px; /* 设置间隔 */
    //  border-bottom: 1px solid #000; /* 添加下边框 */
     width: 100%;
     height: 100%;
     box-sizing: border-box; /* 确保边框包含在高度内 */
  // margin: 30px 0;
.carousel_item_box {
  box-sizing: border-box;
  width: 100%;
   margin-right:20px ;
    // width: 32%;
    height: 97%;
    border: 1px solid #D5DCEB;
    border-radius: 20px;
    // background: red;
    .carousel_item_titleImg {
      box-sizing: border-box;
      width: 100%;
      // height: 100%;
      position: relative;
    .carousel_item_img {
        width: 100%;
        height: 227px;
        
        img{
          width: 100%;
          height: 100%;
          border-top-right-radius: 20px;
          border-top-left-radius: 20px;
        }
      }
      .carousel_item_img1 {
        width: 93px;
        height: 86px;
        position: absolute;
        bottom: -31px;
        right: 17px;
        background: #FFFFFF;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
   .carousel_item_title {
       box-sizing: border-box;
       padding:0 20px;
    .carousel_item_title_text {
      font-weight: 600;
      font-size: 20px;
      color: #313A4B;
      margin-top: 50px;
      display: -webkit-box;
      -webkit-line-clamp: 1; /* 显示的行数 */
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .carousel_item_title_text1 {
       width: 100%;
      margin-top: 11px;
      font-weight: 400;
      font-size: 13px;
      color: #57647C;
      line-height: 24px;
      height: 120px;
     display: -webkit-box;
      -webkit-line-clamp: 5; /* 显示的行数 */
      -webkit-box-orient: vertical;
      overflow: hidden;
      div p img{
          width: 100%;
          display: none !important;
          visibility: hidden !important;
          visibility: hidden !important;
      }
      // img{
       
      // }

      //  white-space: nowrap;
    }
   }
   .carousel_item_lawyer {
    width: 100%;
    margin-top: 20px;
    padding: 0 20px;
    display: grid;
    grid-template-columns: repeat(4, 1fr); /* 4列，每列等宽 */
    gap: 10px; /* 设置间隔 */
    width: 100%;
    height: 100%;
    justify-content: space-between;
    .carousel_item_lawyer_body {
      // display: flex;
      .carousel_item_lawyer_box {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .carousel_item_lawyer_img {
          width: 66px;
          height: 66px;
          img{
            width: 100%;
            height:100%;
            border-radius:50% ;
          }
        }
        .carousel_item_lawyer_text {
          font-weight: 400;
          font-size: 14px;
          color: #313A4B;
          margin-top: 12px;
        }
      }
    }
   }

}
}



    @media (min-width: 1680px) {

    .legalService{
        .legalService_content {
            width: 1600px;
             margin: 0 auto;
             .legalService_content_carousel {
                .carousel_item_body {
                    display: grid;
                    grid-template-columns: repeat(4, 1fr); /* 4列，每列等宽 */
                    gap: 10px; /* 设置间隔 */
                    width: 100%;
                    height: 100%;
                     .carousel_item_box {
                      width: 97%;
                        // width: 24%;
              }
                }
             }
             
        }
        
    }
    }
    :deep(.carousel__indicators ){
        margin-top: 30px;
    }
  :deep(.el-carousel__button){
        // .el-carousel__button {
            background-color: #0754BD !important;
            width: 70px;
            height: 4px;
        // }
    
  }
:deep(img, video, audio) {
	width: 100%;
}
#allMap {
  height: 400px;
}
</style>